/** URLs des visuels d'interface — servis en WebP (les .jpg restent pour l'OG). */
export function heroUrl(slug: string): string {
  return `/images/heroes/${slug}.webp`;
}
export function thumbUrl(slug: string): string {
  return `/images/scenes/${slug}.webp`;
}
